import AppConfig from "config";
import axios from "axios";

const ResultsController = {
  async listResults(jwtToken, auditId, lote) {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL+`/results`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
        params: {
          audit_id: auditId,
          lote: lote
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching profiles:", error);
      throw error;
    }
  },
  async listaudits(jwtToken) {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO+`results_page/get_audits`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error("Error fetching profiles:", error);
      throw error;
    }
  },
};

export default ResultsController;